export default "__VITE_ASSET__CRfQ6DVi__"